import(/* webpackMode: "eager", webpackExports: ["OfferPageStandaloneSection"] */ "/app/src/components/features/cards/employer/OfferPageStandaloneSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BundleCard"] */ "/app/src/components/templates/employer/job-bundles/cards/BundleCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HireBundleCard"] */ "/app/src/components/templates/employer/job-bundles/cards/HireBundleCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OfferPageAddJobBanner"] */ "/app/src/components/templates/employer/offer/OfferPageAddJobBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OfferPageBackground"] */ "/app/src/components/templates/employer/offer/OfferPageBackground.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OfferPageJobSubtitle"] */ "/app/src/components/templates/employer/offer/OfferPageJobSubtitle.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OfferPageSearchPackage"] */ "/app/src/components/templates/employer/offer/OfferPageSearchPackage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OfferPageServicesTable"] */ "/app/src/components/templates/employer/offer/OfferPageServicesTable.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OfferPageTitle"] */ "/app/src/components/templates/employer/offer/OfferPageTitle.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StandardBundle"] */ "/app/src/components/templates/employer/offer/StandardBundle.tsx");
